import { CollectionSlice } from '../slice'
import { getActiveEvents } from './getActiveEvents'
import { getActiveTypeticketcollections } from './getActiveTypeticketcollections'
import { getBulkData } from './getBulkData'
import { getData } from './getData'
import { getEvents } from './getEvents'
import { initSeats } from './initSeats'

export const CollectionActions = {
  ...CollectionSlice.actions,
  initSeats,
  getData,
  getBulkData,
  getActiveEvents,
  getActiveTypeticketcollections,
  getEvents,
}
